$.fn.datepicker.dates['pt-BR'] = {
    days: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado"
    ],
    daysShort: [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb"
    ],
    daysMin: [
        "Do",
        "Se",
        "Te",
        "Qu",
        "Qu",
        "Se",
        "Sá"
    ],
    months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ],
    monthsShort: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
    ],
    today: "Hoje",
    clear: "Limpar",
    format: "dd/mm/yyyy",
    titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
    weekStart: 0
};

$(function () {
    $(".input-datepicker").datepicker({
        format: window.dateFormat,
        orientation: 'bottom',
        language : 'pt-BR'
    });

    $('.input-daterangepicker').daterangepicker({
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - ",
        applyLabel: "Aplicar",
        cancelLabel: "Cancelar",
        fromLabel: "De",
        toLabel: "Até",
        customRangeLabel: "Custom",
        weekLabel: "S",
          daysOfWeek: [
              "Do",
              "Se",
              "Te",
              "Qu",
              "Qu",
              "Se",
              "Sa"
          ],
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
      }
    });

    $('.input-daterangepicker').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format("DD/MM/YYYY") + ' - ' + picker.endDate.format("DD/MM/YYYY"));
    });
});



// WEBPACK FOOTER //
// ./resources/assets/material/js/custom-datepicker.js